module.exports = __webpack_public_path__ + "547d644a3d8191916fe970991599801f.svg";